<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">The Sweating Sickness Epidemic</h1>
<p class="titlea">Henry VIII’s Great Fear</p>
<p class="author">Stephen Porter</p>
<div class="img_containerf">
<img alt="images" src="images/tit.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?b8115d4c